var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uploader-files"},[_vm._t("default",function(){return [_c('ul',_vm._l((_vm.files),function(file){return _c('li',{key:file.id},[_c('uploader-file',{attrs:{"file":file}})],1)}),0)]},{"files":_vm.files})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1fe352a8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/uploader/components/files.vue
// module id = null
// module chunks = 